import React, { useContext, useEffect, useState } from 'react'
import PrivatePage from '../../../components/PrivatePage'
import WritersBenefitContainer from './WritersBenefit.container'
import WritersBenefitUI from './WritersBenefit.UI'
import WritersBenefitV2UI from './WriterBenefitV2.UI'
import { AccountContext } from '../../../providers/accountProvider'
import { allLanguage } from '../../../languages/index'
import { checkOverseasUser, handlePageLoadEventLog } from '../../../lib/utils'
import Loader from '../../../components/Loader'
import PublicPageBackButtonNavbar from '../../../components/PublicPage'
import SubTabs from '../../../components/SubTabs'
// import { disabledMessageForWBPUS } from '../../../constants'

// const isWebIPFromIndia = ip => ['IN','BD','PK','NP','LK'].includes(ip)
// const isWebIPFromUS = ip => ip === 'US'

const langauagePresentChecker = (language) => Object.values(allLanguage).includes(language) 

const WritersBenefitPrivatePage = ({language='english', ...props}) => {
  const { user, isHindiUgcUser } = useContext(AccountContext)
  if (!user.languages) return <Loader/>
  if (langauagePresentChecker(user.languages)) {
    if (user.languages === "hindi") return (
      <WritersBenefitContainer {...props}>
        <WritersBenefitV2UI {...props} language={'hindi'}/> 
      </WritersBenefitContainer>)
    else if (user.languages === "english" || user.languages === "tamil") return (
      <WritersBenefitContainer {...props}>
        <WritersBenefitV2UI {...props} isUserFromUS={user?.languages === 'english'} language={'english'}/> 
      </WritersBenefitContainer>)
    else return (
      <WritersBenefitContainer {...props}>
        <WritersBenefitUI {...props} language={user.languages}/> 
      </WritersBenefitContainer>)
  }
  window.location.href = '/'
  return null
}

const WritersBenefit = (props) => {
  const urlLink = props.location.pathname.split("/");
  const isAuthorWelfarePath = urlLink[1] === 'author-welfare' 
  isAuthorWelfarePath ? window?.fcWidget?.hide() : window?.fcWidget?.show()
  const screenName = urlLink[2] ? urlLink[1] + `-${urlLink[2]}` : urlLink[1]

  useEffect(() => {
    handlePageLoadEventLog(screenName)
  },[])

  // public pages
  // /author-welfare
  if ((urlLink[1] === 'author-welfare' || urlLink[1] === 'author-welfare-audioseries') && !langauagePresentChecker(urlLink[2])) 
    return (
      <PublicPageBackButtonNavbar>
        <WritersBenefitV2UI language={'english'} isUserFromUS={urlLink[1] === 'author-welfare-audioseries'} screenName={screenName} {...props} />
      </PublicPageBackButtonNavbar>
    )

  // /author-welfare/hindi
  if((urlLink[1] === 'author-welfare' || urlLink[1] === 'author-welfare-audioseries') && urlLink[2] === 'hindi')
    return (
      <PublicPageBackButtonNavbar>
        <WritersBenefitV2UI language={urlLink[1] === 'author-welfare-audioseries' ? 'hindiUGC' : 'hindi'} isHindiSeries={urlLink[1] === 'author-welfare-audioseries' && urlLink[2] === 'hindi'} screenName={screenName} {...props} />
      </PublicPageBackButtonNavbar>
    )
    
  // /author-welfare/english or  /author-welfare/tamil
  if(urlLink[1] === 'author-welfare' && (urlLink[2] === 'english' || urlLink[2] === 'tamil'))
    return (
      <PublicPageBackButtonNavbar>
        <WritersBenefitV2UI language={'english'} screenName={screenName} {...props} />
      </PublicPageBackButtonNavbar>
    )

  // any other language except hindi, english, tamil
  if (urlLink[1] === 'author-welfare' && langauagePresentChecker(urlLink[2]))
    return (
      <PublicPageBackButtonNavbar>
        <WritersBenefitUI language={'marathi'} screenName={screenName} {...props} />
      </PublicPageBackButtonNavbar>
    )

  return (
    <PrivatePage>
      <WritersBenefitPrivatePage screenName={screenName} {...props} />
    </PrivatePage>
  )
}

export default WritersBenefit
